import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogram/area/";

export default class AreaApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getAreas(params) {
    return await request.post(`${rootRoute}getAreas`, {
      filter: params,
      parameters: {},
    });
  }
  async getArea(id) {
    return await request.post(`${rootRoute}getAreas`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createArea(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createArea`, { data });
  }
  async deleteArea(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteArea`, { data });
  }
  async editArea(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateArea`, { data });
  }
  async import(gfid) {
    return await request.post(`${rootRoute}importArea`, {
      gfid: gfid
    });
  }
  async getImportScaffold() {
    return await request.post(`${rootRoute}getAreaimporttemplate`, null, { responseType: 'blob' });
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportArea`, {
      filter: filter,
      format: format
    });
  }
}
